import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { Card, Text, Title, useBreakpoint } from '@hh.ru/magritte-ui';

import { useCalculatorContext } from 'src/pages/Profession/components/SectionCalculator/Context';

import SelectedSkillsItem from 'src/pages/Profession/components/SectionCalculator/SelectedSkills/SelectedSkillsItem';

import styles from './styles.less';

const TrlKeys = {
    title: 'career-platform.profession.sections.calculator.selected-skills.title',
    description: 'career-platform.profession.sections.calculator.selected-skills.description',
    withoutCourses: 'career-platform.profession.sections.calculator.selected-skills.without-courses',
};

const SelectedSkills: TranslatedComponent = ({ trls }) => {
    const { professionId, gradeId, selectedSkills } = useCalculatorContext();
    const { isSelectSkills, withCourse, withoutCourse } = selectedSkills;

    const { isMobile } = useBreakpoint();

    return (
        <Card
            padding={isMobile ? 16 : 24}
            borderRadius={isMobile ? 16 : 32}
            borderBottomLeftRadius={isMobile ? 24 : 32}
            borderBottomRightRadius={isMobile ? 24 : 32}
            style="neutral"
            showBorder
            stretched
        >
            <div className={styles.content}>
                <header>
                    <Title
                        size={isMobile ? 'small' : 'medium'}
                        description={!isSelectSkills && trls[TrlKeys.description]}
                        Element="h2"
                    >
                        {trls[TrlKeys.title]}
                    </Title>
                </header>
                {!!withCourse.length && (
                    <div className={styles.list}>
                        {withCourse.map((item, index) => (
                            <SelectedSkillsItem
                                key={item.id}
                                defaultIsOpen={index === 0}
                                skill={item}
                                professionId={professionId}
                                gradeId={gradeId}
                            />
                        ))}
                    </div>
                )}
                {!!withoutCourse.length && (
                    <div>
                        <div className={styles.secondaryTitle}>
                            <Text typography="label-3-regular" style="secondary" Element="p">
                                {trls[TrlKeys.withoutCourses]}
                            </Text>
                        </div>
                        <div className={styles.list}>
                            {withoutCourse.map((item, index) => (
                                <SelectedSkillsItem
                                    key={item.id}
                                    defaultIsOpen={index === 0}
                                    skill={item}
                                    professionId={professionId}
                                    gradeId={gradeId}
                                />
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </Card>
    );
};

export default translation(SelectedSkills);
